var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1143 0.4375H1.55176C0.866211 0.4375 0.333008 0.996094 0.333008 1.65625V3.28125C0.333008 3.50977 0.510742 3.6875 0.739258 3.6875H1.14551V10.5938C1.14551 11.2793 1.67871 11.8125 2.36426 11.8125H11.3018C11.9619 11.8125 12.5205 11.2793 12.5205 10.5938V3.6875H12.9268C13.1299 3.6875 13.333 3.50977 13.333 3.28125V1.65625C13.333 0.996094 12.7744 0.4375 12.1143 0.4375ZM11.708 10.5938C11.708 10.8223 11.5049 11 11.3018 11H2.36426C2.13574 11 1.95801 10.8223 1.95801 10.5938V3.6875H11.708V10.5938ZM12.5205 2.875H1.14551V1.65625C1.14551 1.45312 1.32324 1.25 1.55176 1.25H12.1143C12.3174 1.25 12.5205 1.45312 12.5205 1.65625V2.875ZM5.5127 6.125H8.15332C8.30566 6.125 8.45801 5.99805 8.45801 5.82031V5.61719C8.45801 5.46484 8.30566 5.3125 8.15332 5.3125H5.5127C5.33496 5.3125 5.20801 5.46484 5.20801 5.61719V5.82031C5.20801 5.99805 5.33496 6.125 5.5127 6.125Z",
    fill: "#383838"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.579b6335.svg";
export { ForwardRef as ReactComponent };